// src/api/api.js
import axios from "axios";
import { logout } from "../../store/authSlice";
import { store } from "../../store/store";
import { crudChanged } from "../../store/crudSync";
import { getOrCreateClientDeviceId } from "../../utils/deviceId";

const backendUrl =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: backendUrl,
});

/**
 * ===============================
 * REQUEST INTERCEPTOR
 * ===============================
 * Automatically attach token
 */
api.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state?.auth?.token;

    if (token) {
      config.headers["x-auth-token"] = token;
    }

    config.headers["x-device-id"] = getOrCreateClientDeviceId();

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * ===============================
 * RESPONSE INTERCEPTOR (FIXED)
 * ===============================
 *
 * RULES:
 * 401 → LOGOUT (token expired / invalid)
 * 403 → DO NOT LOGOUT (permission issue)
 */
api.interceptors.response.use(
  (response) => {
    const method = String(response?.config?.method || "get").toLowerCase();
    if (["post", "put", "patch", "delete"].includes(method) && store) {
      store.dispatch(crudChanged({ source: "axios-instance", method }));
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    // 🔴 ONLY logout on 401
    if (status === 401) {
      console.error("🔴 Token expired (401). Logging out...");
      if (store) {
        store.dispatch(logout());
      }
    }

    // 🟡 403 = Permission issue → NO logout
    if (status === 403) {
      console.warn(
        "🟡 Permission denied (403):",
        error?.response?.data?.msg || "Not allowed"
      );
      // ❌ DO NOTHING (popup handled elsewhere)
    }

    return Promise.reject(error);
  }
);

export default api;
